import { Divider, Stack } from "@mui/material";
import React from "react";
import { useAppSelecter } from "../../../../hooks/storeHooks";
import { RootState } from "../../../../store/store";
import {
  allModules,
  descriptionInput,
  internalRemarkInput,
  languages,
  ModuleDetails,
} from "../../../../store/slices/constants/staticContents";
import { ObjectValues } from "../../../login";
import { convertFirstUpper } from "../../../../Regex";
import FormComponent from "../../../../Components/FormComponent";
import FormFoeClone from "./FormFoeClone";

function ConfirmationCloneTemplate({
  tempSelected,
  selectedData,
  cardsSelected,
  level,setRowData,rowData,showForm
}: any) {
  console.log(selectedData, tempSelected, "tempSelected");
  React.useEffect(() => {
    if (tempSelected?.data) {
      setRowData({
        ...tempSelected.data,
        name:
          level === "exam"
            ? `Copy of ${tempSelected.data.name}`
            : tempSelected.data.name,
      });
    }
  }, [tempSelected?.data]);
  const normalizeArray = (data: any) =>
    data ? (Array.isArray(data) ? data : [data]) : [];

  const examsData = useAppSelecter((state: ObjectValues) => state.exams);
  const tags_list = examsData.tags_list ?? [];
  const depth = cardsSelected.cluster
    ? "cluster"
    : cardsSelected.subtopic
    ? "subtopic"
    : cardsSelected.topic
    ? "topic"
    : cardsSelected.unit
    ? "unit"
    : cardsSelected.section
    ? "section"
    : cardsSelected.goal
    ? "goal"
    : "exam";
  const exams = normalizeArray(selectedData.exams);
  const goals = normalizeArray(selectedData.goals);
  const sections = normalizeArray(selectedData.sections);
  const units = normalizeArray(selectedData.units);
  const topics = normalizeArray(selectedData.topics);
  const subtopics = normalizeArray(selectedData.subtopics);
  const clusters = normalizeArray(selectedData.clusters);

  console.log(rowData, "rowData");

  //     [level]: {
  //       name:
  //         level === "exam"
  //           ? `Copy of ${tempSelected.data.name}`
  //           : tempSelected.data.name,
  //     },
  //   }
  const hierarchyLevels = [
    "exam",
    "goal",
    "section",
    "unit",
    "topic",
    "subtopic",
    "cluster",
  ];
  const title = `${level}s`;
  const formProps = {
  formatPayload:  (data: ObjectValues) => {
      const newObj = {
        name: data.name,
        internal_remark: data.internal_remark,
        status: data.status,
          description: data.description,
        is_active: true,
        exam: data.exam,
        tag: [],
        [data.date_type === "announced"
          ? "publish_date"
          : "tentative_publish_date"]: data.date,
      };
      return newObj;
  
  },
    inputFormArray: [
      {
        label: "Exam Name",
        placeholder: "Enter Exam Name",
        value: "",
        error: false,
        helperText: " c",
        endAdornment: "",
        fieldType: "text",
        api: "name",
      },
      {
        label: "Primary Language",
        placeholder: "Select Primary Language of Exam",
        value: undefined,
        list: languages.map((it: string) => {
          return {
            label: convertFirstUpper(it),
            id: it,
            value: convertFirstUpper(it),
          };
        }),
        defaultValue: {
          value: rowData?.primary_language
            ? convertFirstUpper(rowData?.primary_language)
            : "",
          id: rowData?.primary_language,
        },
        error: false,
        helperText: " c",
        endAdornment: "",
        fieldType: "autocomplete" as "autocomplete",
        listLabel: "label",
        api: "primary_language",
        // freeSolo:true
      },
      descriptionInput(),
      internalRemarkInput(),
    ],
    header: title,
    editData: rowData,
    onClear: () => {},
  };
  function getHierarchyToCopy(depth: string) {
    const startIndex = hierarchyLevels.indexOf(level);
    const endIndex = hierarchyLevels.indexOf(depth);
    if (startIndex === -1) return [];
    console.log(hierarchyLevels, startIndex, depth, "hierarchyLevels");
    return hierarchyLevels
      .slice(startIndex + 1, endIndex + 1)
      .map(
        (lvl) =>
          `(${
            lvl === "exam"
              ? exams.length
              : lvl === "goal"
              ? goals.length === 0
                ? tempSelected.data.total_goals
                : goals.length
              : lvl === "section"
              ? sections.length === 0
                ? tempSelected.data.total_sections
                : sections.length
              : lvl === "unit"
              ? units.length === 0
                ? tempSelected.data.total_units
                : units.length
              : lvl === "topic"
              ? topics.length === 0
                ? tempSelected.data.total_topics
                : topics.length
              : lvl === "subtopic"
              ? subtopics.length === 0
                ? tempSelected.data.total_subtopics
                : subtopics.length
              : lvl === "cluster"
              ? clusters.length === 0
                ? tempSelected.data.total_clusters
                : clusters.length
              : 0
          }) ${lvl}${
            (lvl === "exam"
              ? exams.length
              : lvl === "goal"
              ? goals.length === 0
                ? tempSelected.total_goals
                : goals.length
              : lvl === "section"
              ? sections.length === 0
                ? tempSelected.total_sections
                : sections.length
              : lvl === "unit"
              ? units.length === 0
                ? tempSelected.total_units
                : units.length
              : lvl === "topic"
              ? topics.length === 0
                ? tempSelected.total_topics
                : topics.length
              : lvl === "subtopic"
              ? subtopics.length === 0
                ? tempSelected.total_subtopics
                : subtopics.length
              : lvl === "cluster"
              ? clusters.length === 0
                ? tempSelected.total_clusters
                : clusters.length
              : 0) > 1
              ? "s"
              : ""
          }.`
      );
  }

  return (
    <Stack>
      Along with its{" "}
      {(() => {
        const levels = getHierarchyToCopy(depth);
        if (levels.length === 0) return "";
        if (levels.length === 1) return levels[0];
        return (
          levels.slice(0, -1).join(", ") + " and " + levels[levels.length - 1]
        );
      })()}
      <Divider sx={{ m: "10px 0" }} />
    {showForm&&  <FormFoeClone
        {...formProps}
        onDataUpdate={(val: any) => {
          console.log(val, "valvalval");
          if (JSON.stringify(val) !== JSON.stringify(rowData)) setRowData(val);
        }}
      />}
    </Stack>
  );
}

export default ConfirmationCloneTemplate;
